/**
 * Universal date-time formatting helpers.
 * All user-facing dates use `dd-MM-yyyy HH:mm` (or `dd-MM-yyyy` when only the date is relevant).
 */

function pad(n) {
  return String(n).padStart(2, "0");
}

export function formatDateTime(input) {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatDate(input) {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
}

export function formatTime(input) {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * The universal placeholder shown in every free-form date input.
 */
export const DATE_PLACEHOLDER = "dd-MM-yyyy";
export const DATETIME_PLACEHOLDER = "dd-MM-yyyy HH:mm";
